(function () {
  'use strict';

  function initMegaMenuShopNow(container) {
    var tabs = container.querySelectorAll('.mega-menu-shop-now__tab');
    var contentPanels = container.querySelectorAll('.mega-menu-shop-now__panel');
    var tabFeaturedPanels = container.querySelectorAll('.mega-menu-shop-now__featured-panel--tab');
    var linkFeaturedPanels = container.querySelectorAll('.mega-menu-shop-now__featured-panel--link');
    var navLinks = container.querySelectorAll('.mega-menu-shop-now__nav-link');
    var panelsContainer = container.querySelector('.mega-menu-shop-now__panels');

    if (!tabs.length) return;

    var activeTabId = null;

    function setPanelVisibility(panel, visible) {
      panel.classList.toggle('is-active', visible);
      if (visible) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    }

    function hideAllFeatured() {
      tabFeaturedPanels.forEach(function (panel) {
        setPanelVisibility(panel, false);
      });
      linkFeaturedPanels.forEach(function (panel) {
        setPanelVisibility(panel, false);
      });
    }

    function showTabDefaultFeatured(tabId) {
      hideAllFeatured();
      tabFeaturedPanels.forEach(function (panel) {
        if (panel.getAttribute('data-panel') === tabId) {
          setPanelVisibility(panel, true);
        }
      });
    }

    function showLinkFeatured(featureKey) {
      var linkPanel = container.querySelector(
        '.mega-menu-shop-now__featured-panel--link[data-feature-key="' + featureKey + '"]'
      );

      if (!linkPanel) {
        showTabDefaultFeatured(activeTabId);
        return;
      }

      hideAllFeatured();
      setPanelVisibility(linkPanel, true);
    }

    function clearLinkHighlights() {
      navLinks.forEach(function (link) {
        link.classList.remove('is-active');
      });
    }

    function activateTab(tabId) {
      activeTabId = tabId;

      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-tab') === tabId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      contentPanels.forEach(function (panel) {
        setPanelVisibility(panel, panel.getAttribute('data-panel') === tabId);
      });

      clearLinkHighlights();
      showTabDefaultFeatured(tabId);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('mouseenter', function () {
        activateTab(tab.getAttribute('data-tab'));
      });

      tab.addEventListener('focus', function () {
        activateTab(tab.getAttribute('data-tab'));
      });
    });

    navLinks.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        clearLinkHighlights();
        link.classList.add('is-active');

        var featureKey = link.getAttribute('data-feature-key');
        if (featureKey) {
          showLinkFeatured(featureKey);
        }
      });

      link.addEventListener('focus', function () {
        link.dispatchEvent(new Event('mouseenter'));
      });
    });

    if (panelsContainer) {
      panelsContainer.addEventListener('mouseleave', function (evt) {
        if (evt.relatedTarget && panelsContainer.contains(evt.relatedTarget)) {
          return;
        }
        clearLinkHighlights();
        if (activeTabId) {
          showTabDefaultFeatured(activeTabId);
        }
      });
    }

    var firstTab = tabs[0];
    if (firstTab) {
      activateTab(firstTab.getAttribute('data-tab'));
    }
  }

  function init() {
    document.querySelectorAll('[data-mega-menu-shop-now]').forEach(initMegaMenuShopNow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var container = evt.target.querySelector('[data-mega-menu-shop-now]');
    if (container) initMegaMenuShopNow(container);
  });
})();
